"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import Image from "next/image";

export default function NotFound() {
  const hasLogged = useRef(false);

  useEffect(() => {
    if (hasLogged.current || typeof window === "undefined") return;
    hasLogged.current = true;

    fetch("/api/logs", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        keyError: "PAGE_NOT_FOUND_404",
        errorMsg: `Ruta 404 no encontrada: ${window.location.pathname}`,
        url: window.location.href,
        method: "GET",
        errorDetails: {
          pathname: window.location.pathname,
          referrer: document.referrer || "Directo",
          userAgent: navigator.userAgent,
        },
      }),
    }).catch(() => {});
  }, []);

  return (
    <div className="grid min-h-[calc(100vh-200px)] place-items-center py-2 sm:py-4 md:py-4 lg:py-6 xl:py-6 2xl:py-6">
      <section className="grid w-full max-w-140 grid-cols-1 justify-items-center rounded-3xl border border-primary/10 bg-primary/5 px-5 pb-6 pt-6 text-center shadow-[0_20px_45px_rgba(32,45,72,0.10),0_4px_12px_rgba(32,45,72,0.05)] sm:rounded-3xl sm:px-8 sm:pb-7 sm:pt-7 md:rounded-3xl md:px-8 md:pb-7 md:pt-7 lg:rounded-3xl lg:px-10 lg:pb-8 lg:pt-8 xl:rounded-3xl xl:px-10 xl:pb-8 xl:pt-8 2xl:rounded-3xl 2xl:px-10 2xl:pb-8 2xl:pt-8">
        <Image
          src="/adibot-404.webp"
          alt="Adibot, el robot de ADISES"
          width={600}
          height={600}
          priority
          className="mx-auto mb-2 h-auto w-full max-w-75 drop-shadow-[0_12px_22px_rgba(42,49,90,0.10)]"
        />

        <h1 className="mb-2.5 mt-2 text-2xl font-extrabold leading-tight text-foreground sm:text-[28px] md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl">
          Adibot no tiene esta página en su base de datos.
        </h1>

        <p className="max-w-107.5 text-[15px] leading-relaxed text-muted-foreground sm:text-base md:text-base lg:text-base xl:text-base 2xl:text-base">
          El enlace pudo cambiar o el contenido ya no está disponible.
        </p>

        <div className="mt-6.5 grid w-full max-w-70 grid-cols-1 sm:w-auto sm:max-w-none md:w-auto md:max-w-none lg:w-auto lg:max-w-none xl:w-auto xl:max-w-none 2xl:w-auto 2xl:max-w-none">
          <Link
            href="/"
            className="inline-flex min-w-42.5 items-center justify-center rounded-full border border-primary bg-primary px-5.5 py-3.25 text-[15px] font-bold text-primary-foreground shadow-[0_7px_16px_rgba(19,94,170,0.18)] transition-all duration-200 hover:-translate-y-px hover:bg-primary/90 hover:shadow-[0_9px_20px_rgba(19,94,170,0.24)] focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-primary/30"
          >
            Ir al inicio
          </Link>
        </div>

        <section
          aria-labelledby="help-title"
          className="mt-7 w-full border-t border-border pt-5.5 sm:mt-8 sm:pt-6 md:mt-8 md:pt-6 lg:mt-8 lg:pt-6 xl:mt-8 xl:pt-6 2xl:mt-8 2xl:pt-6"
        >
          <h2 id="help-title" className="mb-1.5 text-[17px] font-extrabold text-secondary">
            ¿Necesitas ayuda?
          </h2>
          <p className="text-sm leading-normal text-muted-foreground">
            Contáctanos y con gusto te apoyamos.
          </p>
          <Link
            href="/contacto"
            className="mt-2.25 inline-block text-sm font-bold text-primary underline decoration-1 underline-offset-4 transition-colors duration-200 hover:text-primary/80 focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-primary/30"
          >
            Contáctanos
          </Link>
        </section>
      </section>
    </div>
  );
}
